export const CLIENT_FIELD_HELP_TEXTS = {
  clientPayOop:
    'Indicates when the client is responsible for out-of-pocket costs such as copay, coinsurance, deductible, or uncovered balances.',
  patientRelationshipToInsurer:
    'Indicates whether the client is the insurance subscriber. Turn on when the client bills under their own coverage; turn off when coverage is through another responsible person.',
  paymentPlan:
    'Indicates whether the client has a payment plan configured.',
} as const;
